import { render, staticRenderFns } from "./TemplatePrice.vue?vue&type=template&id=6913fd94&"
import script from "./TemplatePrice.vue?vue&type=script&lang=ts&"
export * from "./TemplatePrice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports